import { SUMMARYPAGE_FILTERS_MUTATION, SUMMARYPAGE_SEE_ALL_MUTATION } from '../mutation-types';

export const namespaced = true;

export const state = {
  namespaced: true,
  pageFilters:[],
  seeAllSummaryData:[]
};

export const actions = {    
};

export const mutations = {   
    [SUMMARYPAGE_FILTERS_MUTATION](state, pageFilter){
        var index= null;
        if(state.pageFilters) {
            index = state.pageFilters.findIndex((obj => obj.pageName == pageFilter.pageName && obj.filterName == pageFilter.filterName));
        }
        else {
            state.pageFilters = [];
            index = -1;
        }
        
        if(index != -1) {
            state.pageFilters[index].filterValue = pageFilter.filterValue;
        }
        else {
            state.pageFilters.push(pageFilter);
        }
    }, 
    [SUMMARYPAGE_SEE_ALL_MUTATION](state, pageData){
        var data = state.seeAllSummaryData.filter(row=>row.pageName == pageData.pageName);
        if(data.length > 0) {
            let filter = data[0];
            filter.pageName = pageData.pageName
            filter.seeAllMode = pageData.seeAllMode;
            filter.itemsPerPage = pageData.itemsPerPage;
            filter.seeAllText = pageData.seeAllText
        }
        else{
            state.seeAllSummaryData.push(pageData)
        }
    }
};

export const getters = {
};